// extracted by mini-css-extract-plugin
module.exports = {"spacer":"MenuSpacer_spacer__nViw8"};